export function redirectLogin (idaasUrl) {
  window.stop() // 停止加载新的资源
  const elm = document.createElement('a')
  elm.href = idaasUrl
  const searchParams = new URLSearchParams(elm.search)
  searchParams.append('redirect_url', window.location.href)
  elm.search = '?' + searchParams.toString()
  window.location.href = elm.href
}
